module.exports = __webpack_public_path__ + "static/images/callout_3.b733ef4659fd4e0bc97c3f920fac8d2b.jpg";